'use strict';

import controller from './cronogramas.controller';
import template from './cronogramas.html';
import './cronogramas.scss';

const cronogramasComponent = {
  bindings: {
    proyecto: '='
  },
  controller,
  template
};

export default cronogramasComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/cronogramas/cronogramas.component.js